export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=template&id=bdaad6e6"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/modal/modal.vue?vue&type=template&id=bdaad6e6
// module id = tnf+
// module chunks = 37